import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRuBoxberry({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        fill="#B0CB1F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 18.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM4 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM16 18.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM16 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM20 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        fill="#E51B4B"
      />
    </svg>
  )
}

export default SvgRuBoxberry
